import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacilityModel } from 'src/app/models/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProjectService } from 'src/app/services/project.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ConfigurationField, ConfigurationType } from '../configurationField';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'facility',
  templateUrl: './facility.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class FacilityComponent implements OnInit {

  configurationController : ConfigurationService;
  configurationField : ConfigurationField;
  form : FormGroup;
  constructor(configurationController : ConfigurationService,
    private projectService : ProjectService,
    private utilsService : UtilsService,
    public bsModalRef : BsModalRef,
    private changeDetectorRef: ChangeDetectorRef
    ) {
      this.configurationController = configurationController;
      this.configurationField = new ConfigurationField(configurationController,utilsService, ConfigurationType.facility)
    }

  ngOnInit(): void {
    this.configurationController.saveChangesState();
    this.form = new FormGroup({
      docMaxRange: new FormControl(this.configurationController.currentConfiguration.facilityConfiguration.docMaxRange,[Validators.min(1),Validators.max(500)]),
      docMaxAltitudeM: new FormControl(this.configurationController.currentConfiguration.facilityConfiguration.docMaxAltitudeM,[Validators.min(0),Validators.max(18288)]),
      docMaxAltitudeFT: new FormControl(this.configurationController.currentConfiguration.facilityConfiguration.docMaxAltitudeFT,[Validators.min(0),Validators.max(60000)]),
      antenaMaxHeightM: new FormControl(this.configurationController.currentConfiguration.facilityConfiguration.antenaMaxHeightM,[Validators.min(0),Validators.max(500.18)]),
      antenaMaxHeightFT: new FormControl(this.configurationController.currentConfiguration.facilityConfiguration.antenaMaxHeightFT,[Validators.min(0),Validators.max(1641)]),
      aboveTerrainLimitM: new FormControl(this.configurationController.currentConfiguration.facilityConfiguration.aboveTerrainLimitM,[Validators.min(0),Validators.max(500.18)]),
      aboveTerrainLimitFT: new FormControl(this.configurationController.currentConfiguration.facilityConfiguration.aboveTerrainLimitFT,[Validators.min(0),Validators.max(1641)])
    })

  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.cancelConfiguration(false); // escape key already hides the modal
  }

  cancelConfiguration(hideModal: boolean = true):void {
    this.configurationController.cancelConfigurationPopup();
    hideModal? this.bsModalRef.hide(): false;
  }

  saveConfiguration():void {
    if (!this.projectService.projectEditable()) {
      this.cancelConfiguration();
      return;
    }
    this.configurationController.saveConfigurationPopup(this.form);
    this.bsModalRef.hide();
  }

  retoreDefaults(){
    let facilityConfiguration: FacilityModel = new FacilityModel();

    facilityConfiguration.docMaxRange = 160;
    facilityConfiguration.docMaxAltitudeM = 18288;
    facilityConfiguration.docMaxAltitudeFT = 60000;
    facilityConfiguration.antenaMaxHeightM = 6;
    facilityConfiguration.antenaMaxHeightFT = 19.69;
    facilityConfiguration.aboveTerrainLimitM = 150;
    facilityConfiguration.aboveTerrainLimitFT = 492.13;

    this.configurationController.currentConfiguration.facilityConfiguration = facilityConfiguration;
  }

  updateDocMaxRange(value: number){
    this.configurationController.currentConfiguration.facilityConfiguration.docMaxRange = value;
  }

  updateFacilityField(unit:String,fieldName:string, value:number){
    this.configurationController.currentConfiguration.facilityConfiguration[fieldName+unit] = +value
    if(unit == "M"){
      this.configurationController.currentConfiguration.facilityConfiguration[fieldName+"FT"] = +this.utilsService.metersToFeet(value).toFixed(2);
    }
    else{
      this.configurationController.currentConfiguration.facilityConfiguration[fieldName+"M"] = +this.utilsService.feetToMeters(value).toFixed(2);
    }
  }





  /*
  updateDocMaxAltitude(type: string, value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.facility.docMaxAltitudeM= this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.facility.docMaxAltitude= value
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.facility.docMaxAltitudeFT= this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.facility.docMaxAltitude= this.utilsService.feetToMeters(value);
    }
    else{
      //ERROR
    }
  }
  updateAntenaMaxHeight(type: string, value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.facility.antenaMaxHeightM= this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.facility.antenaMaxHeight= value
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.facility.antenaMaxHeightFT= this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.facility.antenaMaxHeight= this.utilsService.feetToMeters(value);
    }
    else{
      //ERROR
    }
  }
  updateAboveTerrain(type: string, value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.facility.aboveTerrainLimitFT= this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.facility.aboveTerrainLimit= value
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.facility.aboveTerrainLimitFT= this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.facility.aboveTerrainLimit= this.utilsService.feetToMeters(value);
    }
    else{
      //ERROR
    }
  }

  updateSingleLevelAltitudeValue(type: string,value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitude = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitude = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }

  updateMaxAltitudeValue(type: string,value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.defaultAltitudes.maxAltitudeM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.defaultAltitudes.maxAltitude = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.defaultAltitudes.maxAltitudeFT = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.defaultAltitudes.maxAltitude = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }

  updateAltitudeIncrementValue(type: string,value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrementM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrement = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrementFT = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.defaultAltitudes.altitudeIncrement = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }

  updateMinAltitudeValue(type: string,value: number){
    if(type == "m"){
      this.configurationController.currentConfiguration.defaultAltitudes.minAltitudeM = this.utilsService.feetToMeters(value);
      this.configurationController.currentConfiguration.defaultAltitudes.minAltitude = value;
    }
    else if(type == "ft"){
      this.configurationController.currentConfiguration.defaultAltitudes.minAltitudeFT = this.utilsService.metersToFeet(value);
      this.configurationController.currentConfiguration.defaultAltitudes.minAltitude = this.utilsService.metersToFeet(value);
    }
    else{
      //ERROR
    }
  }*/

}
